var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"primary"},[_c('v-content',[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"pr-3",attrs:{"color":"transparent","dark":"","app":""}},[_c('v-spacer'),_vm._v(" "),_c('div',[_vm._v("v"+_vm._s(_vm.version))])],1),_vm._v(" "),_c('ac-snackbar')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb6400e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 